import React from 'react';

export const inputClassName =
  'shadow appearance-none rounded-lg border border-black w-full py-2 px-3 text-gray-700 leading-tight placeholder-gray-500';

interface TextInputProps {
  label: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
}

const TextInput: React.FC<TextInputProps> = ({ label, type = 'text', value, onChange, placeholder, className }) => {
  className = className ? className : inputClassName;
  return (
    <label className="block">
      <span className="text-lg text-gray-700">{label}</span>
      <input type={type} value={value} onChange={onChange} className={className} placeholder={placeholder} />
    </label>
  );
};

export default TextInput;
